/**
 * Zambian mobile numbers as people write them: "+260971000004" → "097 100 0004".
 * The server keeps E.164; anything that is not a Zambian mobile number is shown as given.
 */
export function formatPhone(e164: string): string {
  const digits = e164.replace(/\D/g, '')
  const local = digits.startsWith('260') && digits.length === 12 ? `0${digits.slice(3)}` : digits
  if (/^0[79]\d{8}$/.test(local)) return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`
  return e164
}
